import { render } from "./DealsPage.vue?vue&type=template&id=b40f9262&scoped=true"
import script from "./DealsPage.vue?vue&type=script&lang=js"
export * from "./DealsPage.vue?vue&type=script&lang=js"

import "./DealsPage.vue?vue&type=style&index=0&id=b40f9262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b40f9262"]])

export default __exports__